import HelperEnv from '../helpers/HelperEnv';
import HelperApis from '../helpers/HelperApis';
import HelperVehicle from '../helpers/HelperVehicle';
import { rejectPostsUnauthorised } from './actionsApi';

/******************************************************
 *
 * Reusable
 *
 ******************************************************/

function completeFunctionnalPayload(state, functionnalPayload, customer) {
    var context = functionnalPayload.context;
    var vehicle = functionnalPayload.vehicle;
    var parameters = functionnalPayload.parameters;
    var partExchange = functionnalPayload.partExchange;
    if (context == null && state.testCriteria.context != null) {
        context = state.testCriteria.context;
    }
    if (customer != null) {
        context = { ...context, customer: customer };
    }
    if (vehicle == null && state.testCriteria.vehicle != null) {
        vehicle = state.testCriteria.vehicle;
    }
    if (parameters == null && state.testCriteria.parameters != null) {
        parameters = state.testCriteria.parametersForFetch;
    }
    if (parameters === '') {
        parameters = null;
    }
    if (partExchange == null && state.testCriteria.partExchange != null) {
        partExchange = state.testCriteria.partExchange;
    }
    if (partExchange === '') {
        partExchange = null;
    }
    return { context: context, vehicle: vehicle, parameters: parameters, partExchange: partExchange }
}

/******************************************************
 *
 * Single vehicle simulation
 *
 ******************************************************/

export const REQUEST_POSTS_SIMU_VEHICLE_DETAILS = 'REQUEST_POSTS_SIMU_VEHICLE_DETAILS';
export const RECEIVE_POSTS_SIMU_VEHICLE_DETAILS = 'RECEIVE_POSTS_SIMU_VEHICLE_DETAILS';
export const REJECT_POSTS_SIMU_VEHICLE_DETAILS = 'REJECT_POSTS_SIMU_VEHICLE_DETAILS';

function requestPostsSimulationVehicleDetails(vehicle) {
    return { type: REQUEST_POSTS_SIMU_VEHICLE_DETAILS, payload: { vehicle: vehicle } }
}
function rejectPostsSimulationVehicleDetails() {
    return { type: REJECT_POSTS_SIMU_VEHICLE_DETAILS }
}
function receivePostsSimulationVehicleDetails(responseSimulationVehicleDetails, isCalculator) {
    return {
        type: RECEIVE_POSTS_SIMU_VEHICLE_DETAILS,
        payload: { responseSimulationVehicleDetails, isCalculator: isCalculator }
    }
}

export function fetchSimulationVehicleDetailsIfNeeded(state, dispatch, functionnalPayload, customer, force, forceOpenDetails) {
    functionnalPayload = completeFunctionnalPayload(state, functionnalPayload, customer);
    var context = functionnalPayload.context;
    var vehicle = functionnalPayload.vehicle;
    var parameters = functionnalPayload.parameters;
    var partExchange = functionnalPayload.partExchange;
    if (shouldFetchSimulation(state, context, vehicle, parameters, state.settings, force, forceOpenDetails)) {
        return fetchSimulationVehicleDetails(dispatch,
            { context: context, vehicle: vehicle, parameters: parameters, partExchange: partExchange },
            state.env, state.settings)
    }
    return null;
}

function shouldFetchSimulation(state, context, vehicle, parameters, settings, force, forceOpenDetails) {
    return (
        HelperEnv.isFetchPossible(state.env, settings)
        && (!state.posts.isFetchingSimulation || force)
        && Object.keys(state.env).length > 0
        && ((settings.process !== 'vehiclesConfig' && settings.process !== 'vehiclesStock' && settings.process !== 'vehiclesDefault') || forceOpenDetails)
        && (HelperVehicle.isEnoughForCalculation(vehicle) || force)
        && (state.testCriteria.context !== context
            || state.testCriteria.vehicle !== vehicle
            || state.testCriteria.parameters !== parameters
            || !state.hasFetchedSimulation
            || force
        )
    );
}
export function fetchSimulationVehicleDetails(dispatch, functionnalPayload, env, settings, isCalculator) {
    var context = functionnalPayload.context;
    var vehicle = functionnalPayload.vehicle;
    var parameters = functionnalPayload.parameters;
    var partExchange = functionnalPayload.partExchange;
    dispatch(requestPostsSimulationVehicleDetails(vehicle));
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    var vehDescType = settings != null && settings.vehDescType != null ? settings.vehDescType : 'MANUFACTURER';
    const url = HelperEnv.getSimulationBaseUrl(env, settings) + HelperEnv.getUriSimulationCalculation(vehDescType);
    const basicAuth = HelperEnv.isAuthSimulationPublic(env, settings) ? HelperApis.getBasicAuth(env) : '';
    var request = {
        context: contextCall,
        vehicle: HelperVehicle.getVehicleResourceSingle(vehicle, vehDescType),
    };
    if (parameters != null && Object.keys(parameters).length > 0) {
        request.parameters = parameters;
    }
    if (partExchange != null && Object.keys(partExchange).length > 0) {
        request.partExchange = partExchange;
    }
    var headers = HelperApis.getHeaderBasicAuth(basicAuth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post',
        headers: headers,
        body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsSimulationVehicleDetails());
        } else {
            return res.json()
        }
        return null;
    }).catch(function (error) {
        dispatch(rejectPostsUnauthorised({ error: error }));
    })
        .then(json => { dispatch(receivePostsSimulationVehicleDetails(json, isCalculator)) });
}


/******************************************************
 *
 * Multiple vehicles simulation
 *
 ******************************************************/

export const REQUEST_POSTS_SIMU_VEHICLES = 'REQUEST_POSTS_SIMU_VEHICLES';
export const RECEIVE_POSTS_SIMU_VEHICLES = 'RECEIVE_POSTS_SIMU_VEHICLES';
export const REJECT_POSTS_SIMU_VEHICLES = 'REJECT_POSTS_SIMU_VEHICLES';

export function fetchSimulationVehiclesIfNeeded(state, dispatch, functionnalPayload, vehicles, settings, customer, force) {
    if(vehicles == null){
        vehicles = {};
    }
    functionnalPayload = completeFunctionnalPayload(state, functionnalPayload, customer);
    if (vehicles.vehiclesConfig == null && state.testCriteria.vehiclesConfig != null) {
        vehicles.vehiclesConfig = state.testCriteria.vehiclesConfig;
    }
    if (vehicles.vehiclesStock == null && state.testCriteria.vehiclesStock != null) {
        vehicles.vehiclesStock = state.testCriteria.vehiclesStock;
    }
    if (settings == null && state.settings != null) {
        settings = state.settings;
    }
    if (shouldFetchSimulationVehicles(state, functionnalPayload.context, vehicles.vehiclesConfig, vehicles.vehiclesStock,
        functionnalPayload.parameters, settings, force)) {
        return fetchSimulationVehicles(dispatch, functionnalPayload, vehicles.vehiclesConfig, vehicles.vehiclesStock, settings, state.env);
    }
    return null;
}

function requestPostsSimulationVehicles() {
    return { type: REQUEST_POSTS_SIMU_VEHICLES }
}
function rejectPostsSimulationVehicles() {
    return { type: REJECT_POSTS_SIMU_VEHICLES }
}
function receivePostsSimulationVehicles(responseSimulationVehicles, vehicles, process) {
    return {
        type: RECEIVE_POSTS_SIMU_VEHICLES,
        payload: { responseSimulationVehicles, vehicles, process }
    }
}

function shouldFetchSimulationVehicles(state, context, vehiclesConfig, vehiclesStock, parameters, settings, force) {
    return (
        HelperEnv.isFetchPossible(state.env, settings)
        && (!state.posts.isFetchingSimulationVehicles || force)
        && (
            (settings.process === 'vehiclesConfig' && vehiclesConfig != null && Object.keys(vehiclesConfig).length > 0)
            || (settings.process === 'vehiclesStock' && vehiclesStock != null && Object.keys(vehiclesStock).length > 0)
            || (settings.process === 'vehiclesDefault' && vehiclesStock != null && Object.keys(vehiclesStock).length > 0)
        )
        && (
            (settings.process === 'vehiclesConfig' && (HelperVehicle.isEnoughForCalculationMultiple(vehiclesConfig) || force))
            || (settings.process === 'vehiclesStock' && (HelperVehicle.isEnoughForCalculationMultiple(vehiclesStock) || force))
            || (settings.process === 'vehiclesDefault' && (HelperVehicle.isEnoughForCalculationMultiple(vehiclesStock) || force))
        )
        && (state.testCriteria.context !== context
            || state.testCriteria.vehiclesConfig !== vehiclesConfig
            || state.testCriteria.vehiclesStock !== vehiclesStock
            || state.testCriteria.parameters !== parameters
            || force
        )
    );
}

function fetchSimulationVehicles(dispatch, functionnalPayload, vehiclesConfig, vehiclesStock, settings, env) {
    const context = functionnalPayload.context;
    const parameters = functionnalPayload.parameters;
    const partExchange = functionnalPayload.partExchange;
    dispatch(requestPostsSimulationVehicles());
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    var isDefault = settings.process === 'vehiclesDefault';
    var isStock = settings.process === 'vehiclesStock' || isDefault;
    var vehicles = isStock ? vehiclesStock : vehiclesConfig;
    var url = isStock ? HelperEnv.getUriSimulationVehiclesStock(settings.vehDescType) : HelperEnv.getUriSimulationVehiclesConfig();
    if (isDefault) {
        url = `${url}/defaults`;
    }
    var auth = HelperApis.getBasicAuthIfPublicApi(env, settings);
    url = HelperEnv.getSimulationBaseUrl(env, settings) + url;
    var vehicles2 = buildVehiclesList(vehicles, isStock, settings);
    var request = {
        context: contextCall,
        vehicles: vehicles2
    };
    if (parameters != null && Object.keys(parameters).length > 0) {
        request.parameters = parameters;
    }
    if (partExchange != null && Object.keys(partExchange).length > 0) {
        request.partExchange = partExchange;
    }
    var headers = HelperApis.getHeaderBasicAuth(auth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post',
        headers: headers,
        body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsSimulationVehicles());
        } else {
            return res.json()
        }
        return null;
    }).catch((error) => {
        dispatch(rejectPostsUnauthorised({ error: error }));
    }).then(json => {
        dispatch(receivePostsSimulationVehicles(json, vehicles, settings.process))
    });
}

function buildVehiclesList(vehicles, isStock, settings) {
    var vehicles2 = [];
    for (var i in vehicles) {
        if (isStock) {
            vehicles2[i] = HelperVehicle.getVehicleResourceConfigKey(vehicles[i], settings.vehDescType);
        } else {
            vehicles2[i] = HelperVehicle.getVehicleResourceMultiMTO(vehicles[i], settings.vehDescType);
        }
    }
    return vehicles2;
}

/******************************************************
 *
 * Option monthly payment increase
 *
 ******************************************************/

export const REQUEST_POSTS_SIMU_OPTIONS = 'REQUEST_POSTS_SIMU_OPTIONS';
export const RECEIVE_POSTS_SIMU_OPTIONS = 'RECEIVE_POSTS_SIMU_OPTIONS';
export const REJECT_POSTS_SIMU_OPTIONS = 'REJECT_POSTS_SIMU_OPTIONS';

export function fetchSimulationOptionsIfNeeded(state, dispatch, functionnalPayload, availableOptions, customer, force) {
    functionnalPayload = completeFunctionnalPayload(state, functionnalPayload, customer);
    if (availableOptions == null && state.testCriteria.availableOptions != null) {
        availableOptions = state.testCriteria.availableOptions;
    }
    if (shouldFetchSimulationOptions(state, functionnalPayload.context, functionnalPayload.vehicle,
        availableOptions, functionnalPayload.parameters, force)) {
        return fetchSimulationOptions(dispatch, functionnalPayload.context, functionnalPayload.vehicle, availableOptions,
            functionnalPayload.parameters, state.env, state.settings);
    }
    return null;
}

function requestPostsSimulationOptions() {
    return { type: REQUEST_POSTS_SIMU_OPTIONS }
}
function rejectPostsSimulationOptions() {
    return { type: REJECT_POSTS_SIMU_OPTIONS }
}
function receivePostsSimulationOptions(responseSimulationOptions) {
    return {
        type: RECEIVE_POSTS_SIMU_OPTIONS,
        payload: { responseSimulationOptions }
    }
}

function shouldFetchSimulationOptions(state, context, vehicle, availableOptions, parameters, force) {
    return (HelperEnv.isFetchPossible(state.env, state.settings)
        && (!state.posts.isFetchingSimulationOption || force)
        && state.settings.process === 'options'
        && availableOptions != null && Object.keys(availableOptions).length > 0
        && (HelperVehicle.isEnoughForCalculation(vehicle) || force)
        && (state.testCriteria.context !== context
            || state.testCriteria.vehicle !== vehicle
            || state.testCriteria.availableOptions !== availableOptions
            || state.testCriteria.parameters !== parameters
            || force
        )
        && vehicle != null
    );
}

function fetchSimulationOptions(dispatch, context, vehicle, availableOptions, parameters, env, settings) {
    dispatch(requestPostsSimulationOptions());
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    var url = HelperEnv.getSimulationBaseUrl(env, settings) + HelperEnv.getUriSimulationOptions();
    var auth = HelperEnv.isAuthSimulationPublic(env, settings) ? HelperApis.getBasicAuth(env) : '';
    var request = {
        context: contextCall,
        vehicle: HelperVehicle.getVehicleResourceSingle(vehicle, settings.vehDescType),
        options: availableOptions
    };
    if (parameters != null && Object.keys(parameters).length > 0) {
        request.parameters = parameters;
    }
    var headers = HelperApis.getHeaderBasicAuth(auth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post',
        headers: headers,
        body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsSimulationOptions());
        } else {
            return res.json()
        }
        return null;
    }).catch((error) => {
        dispatch(rejectPostsUnauthorised({ error: error }));
    }).then(json => { dispatch(receivePostsSimulationOptions(json)) });
}

/******************************************************
 *
 * Accessories monthly payment increase
 *
 ******************************************************/

export const REQUEST_POSTS_SIMU_ACCESSORIES = 'REQUEST_POSTS_SIMU_ACCESSORIES';
export const RECEIVE_POSTS_SIMU_ACCESSORIES = 'RECEIVE_POSTS_SIMU_ACCESSORIES';
export const REJECT_POSTS_SIMU_ACCESSORIES = 'REJECT_POSTS_SIMU_ACCESSORIES';

export function fetchSimulationAccessoriesIfNeeded(state, dispatch, functionnalPayload, availableAccessories, customer, force) {
    functionnalPayload = completeFunctionnalPayload(state, functionnalPayload, customer);
    if (availableAccessories == null && state.testCriteria.availableAccessories != null) {
        availableAccessories = state.testCriteria.availableAccessories;
    }
    if (shouldFetchSimulationAccessories(state, functionnalPayload.context, functionnalPayload.vehicle, availableAccessories,
        functionnalPayload.parameters, force)) {
        return fetchSimulationAccessories(dispatch, functionnalPayload.context, functionnalPayload.vehicle, availableAccessories,
            functionnalPayload.parameters, state.env, state.settings);
    }
    return null;
}

function requestPostsSimulationAccessories() {
    return { type: REQUEST_POSTS_SIMU_ACCESSORIES }
}
function rejectPostsSimulationAccessories() {
    return { type: REJECT_POSTS_SIMU_ACCESSORIES }
}
function receivePostsSimulationAccessories(responseSimulationAccessories) {
    return {
        type: RECEIVE_POSTS_SIMU_ACCESSORIES,
        payload: { responseSimulationAccessories }
    }
}

function shouldFetchSimulationAccessories(state, context, vehicle, availableAccessories, parameters, force) {
    return (HelperEnv.isFetchPossible(state.env, state.settings)
        && (!state.posts.isFetchingSimulationAccessory || force)
        && state.settings.process === 'accessories'
        && availableAccessories != null && Object.keys(availableAccessories).length > 0
        && (HelperVehicle.isEnoughForCalculation(vehicle) || force)
        && (state.testCriteria.context !== context
            || state.testCriteria.vehicle !== vehicle
            || state.testCriteria.availableAccessories !== availableAccessories
            || state.testCriteria.parameters !== parameters
            || force
        )
        && vehicle != null
    );
}

function fetchSimulationAccessories(dispatch, context, vehicle, availableAccessories, parameters, env, settings) {
    var contextCall = HelperApis.getContextAPICall(context, settings, false);
    dispatch(requestPostsSimulationAccessories());
    var url = HelperEnv.getSimulationBaseUrl(env, settings) + HelperEnv.getUriSimulationAccessories();
    var auth = HelperEnv.isAuthSimulationPublic(env, settings) ? HelperApis.getBasicAuth(env) : '';
    var request = {
        context: contextCall,
        vehicle: HelperVehicle.getVehicleResourceSingle(vehicle, settings.vehDescType),
        accessories: availableAccessories
    };
    if (parameters != null && Object.keys(parameters).length > 0) {
        request.parameters = parameters;
    }
    var headers = HelperApis.getHeaderBasicAuth(auth, HelperEnv.getSimuClientId(settings));
    fetch(url, {
        method: 'post', headers: headers, body: JSON.stringify(request)
    }).then(res => {
        if (res.status !== 200) {
            dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
        }
        if (!res.ok) {
            dispatch(rejectPostsSimulationAccessories());
        } else {
            return res.json()
        }
        return null;
    }).catch((error) => {
        dispatch(rejectPostsUnauthorised({ error: error }));
    }).then(json => { dispatch(receivePostsSimulationAccessories(json)) });
}
